import React, { useContext } from 'react'
import './limitexceed.css'
import ReportProblem from '@mui/icons-material/ReportProblem'
import MyContext from '../../Context/AppContext';

const LimitExceed = () => {
    const { openDrawer } = useContext(MyContext);
    return (
        <div className={openDrawer ? 'limitExceedContainer drawerOpen_limitExceedContainer' : 'limitExceedContainer'}>
            <div className='contentContainer_limitExceed'>
                <div className='warningContainer'>
                    <ReportProblem className='reportProbLemIcon' />
                    <span>Job Description Creation Unavailable !!!</span>
                </div>
                <div className='messageContainer_limitExceed'>
                    <span>
                        It looks like your account has expired or you don't have permission to generate job descriptions.
                    </span>
                    <span>
                        Please check your account status or upgrade your plan to proceed.
                    </span>
                    <span>
                        If you wish to upgrade, you can contact us.
                    </span>
                </div>
            </div>

        </div>
    )
}

export default LimitExceed